export class ValueTypeEnums {
  static CPO = 'cpo';
  static OEM_VALUE = 'oem_value';
  static TRADE_IN = 'trade_in';
  static CUSTOM = 'custom';
  static FINANCE = 'finance';
  static DEALER_VALUE = 'dealer_value';

  static getEnumByKey = (key: string) => ValueTypeEnums[key as keyof typeof ValueTypeEnums];
  
  static getEnumValues = () => Object.values(ValueTypeEnums).filter((i) => typeof i !== 'function');
  
  static getEnumKeys = () => Object.keys(ValueTypeEnums).filter((i) => !['getEnumByKey', 'getEnumValues', 'getEnumKeys'].includes(i));
}

export default ValueTypeEnums; 